import { useRef, useState } from "react";
import { api, mediaUrl, formatApiError } from "../lib/api";
import { ImagePlus, Loader2, X } from "lucide-react";
import { toast } from "sonner";

export default function ImageUploader({ value = [], onChange, maxFiles = 12 }) {
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef();

  const handleSelect = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    if (value.length + files.length > maxFiles) {
      toast.error(`Max ${maxFiles} photos`);
      return;
    }
    setUploading(true);
    try {
      const paths = [];
      for (const f of files) {
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post("/listing-photos", fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        paths.push(data.path);
      }
      onChange([...value, ...paths]);
      toast.success("Photo added");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Upload failed");
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  return (
    <div data-testid="image-uploader">
      <div className="flex flex-wrap gap-3 mb-2">
        {value.map((p) => (
          <div key={p} className="relative w-24 h-24 rounded-md overflow-hidden border border-zinc-200 group">
            <img src={mediaUrl(p)} alt="" className="w-full h-full object-cover" />
            <button type="button" onClick={() => onChange(value.filter((x) => x !== p))}
              className="absolute top-1 right-1 bg-black/80 text-white rounded-full p-1"
              data-testid={`remove-photo-${p.split("/").pop()}`}>
              <X className="w-3 h-3" />
            </button>
          </div>
        ))}
        {value.length < maxFiles && (
          <button type="button" onClick={() => fileRef.current?.click()} disabled={uploading}
            className="w-24 h-24 border-2 border-dashed border-zinc-300 hover:border-black rounded-md flex flex-col items-center justify-center gap-1 text-xs text-zinc-500 hover:text-black transition-colors disabled:opacity-50"
            data-testid="upload-photo-btn">
            {uploading ? <Loader2 className="w-5 h-5 animate-spin" /> : <ImagePlus className="w-5 h-5" />}
            <span>Add photo</span>
          </button>
        )}
      </div>
      <input ref={fileRef} type="file" accept="image/jpeg,image/png,image/webp" multiple
        className="hidden" onChange={handleSelect} data-testid="file-input" />
      <p className="text-xs text-zinc-500">JPG, PNG, WEBP · up to 8MB each · max {maxFiles}</p>
    </div>
  );
}
